import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetPlacement } from "../queries/placements";
import { ENTITY } from "../constants";

export const PlacementBreadcrumb = ({ match }) => {
    // Entity
    const { PLACEMENT } = ENTITY;

    const {
      data: placement,
      isLoading,
      isError,
      error,
    } = useGetPlacement(match.params.placementId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (placement) {
      return <span>{trimString(placement[PLACEMENT.nameField], 20)}</span>;
    }
  
    return null;
  };